import axios from "axios";
import * as types from "./mutation_types";

export const getItems = ({ commit }) => {
  commit(types.FONCTIONETP_TOGGLE_LOADING);
  axios
    .get("/api/function_etb/")
    .then((response) => {
      commit(types.FONCTIONETP_TOGGLE_LOADING);
      commit(types.FONCTIONETP_SET_ITEMS, response.data);
    })
    .catch((e) => {
      commit(types.FONCTIONETP_TOGGLE_LOADING);
      commit(types.FONCTIONETP_SET_ERROR, e.message);
    });
};

export const reset = ({ commit }) => {
  commit(types.FONCTIONETP_RESET);
};
